// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n* {\n  box-sizing: border-box;\n}\nhtml {\n  height: 100%;\n}\nbody {\n  width: 100%;\n  height: 100%;\n  /* commented out due to an issue with the onboarding page */\n  /* overflow: hidden; */\n  margin: 0;\n  padding: 0;\n}\nbody::-webkit-scrollbar {\n  display: none;\n}\n.v-main {\n  padding: 40px 0px 0px 0px !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
